import React from "react";
import { ChangeBox } from "src/components/Changes";
import { FeedStackSection } from "src/components/FeedContainer";

export const ContentSectionBelowLg = () => {
  return (
    <FeedStackSection
      renderContent={(row, index) => <ChangeBox key={index} row={row} />}
    />
  );
};
